import React from 'react';

function UserTable({
  users, type = 'users', actions,
}) {
  return (
    <table className="table table-striped mb-0 w-100">
      <thead className="thead-dark">
        <tr>
          <th scope="col">#</th>
          <th scope="col">Gebruikersnaam</th>
          {type !== 'student' && <th scope="col">Code</th>}
          <th scope="col">Naam</th>
          <th scope="col">Acties</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(users).map(key => (
          <tr key={key}>
            <th scope="row">{users[key].id}</th>
            <td style={{ maxWidth: '700px' }}>{users[key].name}</td>
            {type !== 'student' && <td>{users[key].code}</td>}
            <td>
              {users[key].first_name}
              {' '}
              {users[key].last_name}
            </td>
            <td className="py-0 align-middle">
              <a href={`/admin/${type}/${users[key].id}/edit`}>Wijzig</a>
              {' | '}
              <a href={`/dashboard/${users[key].id}/inventory`}>Resultaten</a>
              {actions(users[key])}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

UserTable.defaultProps = {
  actions: () => null,
};

export default UserTable;
